import React from 'react';
import classnames from 'classnames';
import GlobalProps from '../globalProps';
import { getMonths } from '../../util/util';
import './PageHeader.css';

interface Props extends GlobalProps {
  date?: Date;
  title?: React.ReactNode;
  description?: string | string[];
}

export function PageHeader({ date, title, description, className, style }: Props): JSX.Element {
  return (
    <header className={classnames('page-header', className)} style={style}>
      <div className="page-header__content">
        {date && (
          <div className="page-header__date">
            <div className="page-header__day">{date.getDate()}</div>
            <div className="page-header__month">{getMonths('short')[date.getMonth()]}</div>
          </div>
        )}
        <div className="page-header__main">
          {title && <div className="page-header__title">{title}</div>}
          {description && (
            <div className="page-header__description">
              {Array.isArray(description) ? description.map((item) => <span key={item}>{item}</span>) : description}
            </div>
          )}
        </div>
      </div>
    </header>
  );
}
